
  import {Component, Vue} from "vue-property-decorator";

  @Component({})
  export default class LogoTitleBlock extends Vue {
    publicPath = process.env.VUE_APP_PUBLIC_URL;
    isLoading: boolean = true;
  }
